export default class tagSelect {
    constructor() {
        return {
            restrict: 'A',
            scope: {
                destroy: '=',
                load: '=',
                maxItems: '='
            },
            controller: ['$scope', '$timeout', '$element', 'Tag', ($scope, $timeout, $element, Tag) => {
                $timeout(() => {
                    let tagSelect = $($element).selectize({
                        valueField: 'id',
                        labelField: 'name',
                        searchField: 'name',
                        plugins: ['remove_button'],
                        preload: true,
                        create: false,
                        maxItems: $scope.maxItems,

                        render: {
                            item: function(item, escape) {
                                return'<div class="tag-label"><a style="color:inherit;" href="#/tag/' + item.id + '">' +
                                            escape(item.name) +
                                    '</a></div>';
                            }
                        },

                        load: (query, callback) => {

                        if (! query.length) {
                            return Tag.all().then((tags) => {
                                callback(tags.data);
                                $scope.$watch('load', (newVal) => {
                                    if (newVal !== false) {
                                        _.map(newVal, (tag) => {
                                            $timeout(() => {
                                                tagSelect[0].selectize.addOption({ id: tag.id, name: tag.name });
                                                tagSelect[0].selectize.addItem(tag.id);
                                            })
                                        });
                                    }
                                });
                            });
                        }

                            Tag.findByName(query).then((tags) => {
                                callback(tags)
                            })
                        }
                    });

                    // Watch for option to clear selected items
                    $scope.$watch('destroy', (newVal) => {
                        if (! newVal) {
                            return;
                        }

                        $timeout(() => {
                            tagSelect[0].selectize.clear(true)
                        })
                    });
                })
            }]
        }
    }
};
